document.addEventListener('DOMContentLoaded', function () {
	/**
	 * Get Terms
	 */
	const get_terms = async (blockId = '', page = 1, initial = false, scroll = false) => {
		const argsData = document.querySelector(`#${blockId}`).dataset.args;
		const args = typeof argsData === 'string' ? JSON.parse(argsData) : argsData;

		if (!blockId || !args) {
			console.log('There was an issue getting the block id or args');
			return;
		}

		args.initial = initial;

		if (args.hasOwnProperty('terms_loop_pagination') && args.terms_loop_pagination) {
			args.paged = page != 1 ? page : 1;
		}

		// Before sending the request
		if (!initial) {
			const wpBlockTermsLoop = document.querySelector(`#${blockId} .wp-block-terms-loop`);
			if (wpBlockTermsLoop) {
				const loader = document.createElement('div');
				loader.classList.add('loader');
				const span = document.createElement('span');
				if (args.terms_loop_loader) {
					span.classList.add(args.terms_loop_loader);
				}
				loader.appendChild(span);
				wpBlockTermsLoop.prepend(loader);
			}
		}

		const response = await fetch(knightowl_blocks_terms_filter_data.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(args),
		});

		if (response.ok) {
			const result = await response.json();

			if (result.success === true) {
				const termsLoopData = document.querySelector(`#${blockId} .terms-loop-data`);
				if (!initial) {
					termsLoopData.innerHTML = result.data;
				} else {
					termsLoopData.innerHTML += result.data;
				}

				if (scroll === true && args.hasOwnProperty('terms_loop_scroll_top') && args.terms_loop_scroll_top === 1) {
					const termsLoopData = document.querySelector(`#${blockId} .terms-loop-data`);
					if (termsLoopData) {
						window.scrollTo({
							top: termsLoopData.offsetTop - 50,
							behavior: 'smooth'
						});
					}
				}
			} else {
				console.log('An error occurred. Please contact the site administrator.');
			}
		} else {
			console.log('REST request failed:', response.status);
		}
	}

	/**
	 * Initial call
	 */
	const termsLoopElements = document.querySelectorAll('.knightowl-blocks-terms-loop');
	termsLoopElements.forEach(element => {
		const blockId = element.id;
		get_terms(blockId, 1, true);
	});

	/**
	 * Pagination
	 */
	document.querySelector('body').addEventListener('click', function(e) {
		let targetElement = e.target;
		if (targetElement.closest('.pagination') && targetElement.matches('a')) {
			let block = targetElement.closest('.knightowl-blocks-terms-loop');
			if (block) {
				let blockId = block.id;
				let page = parseInt(targetElement.getAttribute('href').replace(/\D/g, '')) || 1;
				get_terms(blockId, page, false, true);
				e.preventDefault();
			}
		}
	});
});
